var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g(_vm._b({attrs:{"color":"red lighten-2"}},'v-btn',Object.assign({}, _vm.$attrs, _vm.$props),false),_vm.$listeners),[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.$t('clear'))+" ")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }